/*
 * sp-lazy.js — fotos de las secciones debajo del fold que esperan a acercarse al viewport (kit Shopify maker,
 * 2026-10-17; PAR-135, CONTRACTS §C).
 *
 * El lazy nativo (loading="lazy") de Chrome pide las imágenes a 1 250-2 500 px del viewport: en una ficha larga eso metía
 * en la carga los pósters de sp-videos, las franjas de text-and-image y las fotos de sp-pains y sp-before-after (ensayo de
 * wheeler-bebe: ~400 KB que empujaban el load del PDP arriba de los 10 s). Con defer: true, sp-asset-image las dibuja con
 * un SVG vacío de la misma proporción como src (0 bytes de red; width/height y la proporción reservan el lugar: sin CLS)
 * y la URL y el srcset reales en data-sp-src / data-sp-srcset. Este script:
 *   - con un solo IntersectionObserver (rootMargin: media pantalla arriba y una pantalla abajo) les pone srcset y src
 *     cuando llegan cerca, una sola vez;
 *   - si la foto está dentro de un [data-sp-lazy-group] (el marquee de sp-videos, con pósters fuera de la pantalla a los
 *     costados y las copias que arma sp-marquee.js; el marco de sp-before-after), mira el grupo y suelta todas sus fotos
 *     juntas (también las copias que ya existan);
 *   - sin IntersectionObserver las carga enseguida; sin JS se ve el <noscript> del snippet;
 *   - sin listeners de scroll ni de gesto y sin rAF; editor de temas: shopify:section:load mira la
 *     sección nueva y shopify:section:unload deja de mirar la vieja.
 * window.spLazy = { init(scope), load(scope) }. Idempotente (lo cargan varias secciones).
 */
(function () {
  'use strict';
  if (window.spLazy && window.spLazy.__kit) return;

  var SEL = 'img[data-sp-src]';
  var GROUP = '[data-sp-lazy-group]';
  var io = null;

  function show(img) {
    var src = img.getAttribute('data-sp-src');
    if (!src) return;
    var srcset = img.getAttribute('data-sp-srcset');
    // ya está cerca: que no espere además al umbral del lazy nativo (el grupo suelta también las de los costados)
    img.loading = 'eager';
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', src);
    img.removeAttribute('data-sp-srcset');
    img.removeAttribute('data-sp-src');
    img.setAttribute('data-sp-lazy', 'loaded');
  }

  function listIn(scope) {
    var root = scope && scope.nodeType === 1 ? scope : document;
    var out = [];
    if (root.nodeType === 1 && root.matches(SEL)) out.push(root);
    var found = root.querySelectorAll(SEL);
    for (var i = 0; i < found.length; i++) out.push(found[i]);
    return out;
  }

  function load(scope) {
    var list = listIn(scope);
    for (var i = 0; i < list.length; i++) show(list[i]);
  }

  function observer() {
    if (io || typeof IntersectionObserver !== 'function') return io;
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        io.unobserve(entries[i].target);
        load(entries[i].target);
      }
    }, { rootMargin: '50% 0px 100% 0px' });
    return io;
  }

  function targetOf(img) {
    return (img.closest && img.closest(GROUP)) || img;
  }

  function init(scope) {
    var list = listIn(scope);
    if (!list.length) return;
    if (!observer()) { load(scope); return; }
    for (var i = 0; i < list.length; i++) io.observe(targetOf(list[i]));
  }

  function forget(scope) {
    if (!io || !scope || scope.nodeType !== 1) return;
    var list = listIn(scope);
    for (var i = 0; i < list.length; i++) io.unobserve(targetOf(list[i]));
  }

  window.spLazy = { __kit: 1, init: init, load: load };

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { forget(e.target); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
